import React from "react";
import { withIntl, IntlProps } from "context/Intl";
import LoaderUI from "ui/Loader";

type Props = IntlProps;

class Loader extends React.Component<Props> {
    render() {
        const { intl } = this.props;

        return (
            <div className="loader-backdrop-wrapper loader-backdrop-wrapper--full">
                <div className="loader-backdrop" />
                <LoaderUI message={intl.formatMessage("generic.loading")} />
            </div>
        );
    }
}

export default withIntl(Loader);
